import { ArrowLeft, Building2, User, Server, Mail } from 'lucide-react';
import { Link } from 'react-router-dom';

const MentionsLegales = () => {
  return (
    <div className="min-h-screen bg-slate-50 py-8 px-4" data-testid="mentions-legales-page">
      <div className="max-w-3xl mx-auto">
        <Link 
          to="/" 
          className="inline-flex items-center gap-2 text-slate-600 hover:text-[#8DC63F] mb-6 transition-colors"
        >
          <ArrowLeft className="h-4 w-4" />
          Retour à l'accueil
        </Link>

        <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-8">
          <h1 className="text-3xl font-display font-bold text-[#0F172A] mb-8">
            Mentions légales
          </h1>

          {/* Éditeur */}
          <section className="mb-8">
            <div className="flex items-center gap-3 mb-4">
              <div className="bg-[#8DC63F]/10 p-2 rounded-lg">
                <Building2 className="h-5 w-5 text-[#8DC63F]" />
              </div>
              <h2 className="text-xl font-semibold text-[#0F172A]">Éditeur de l'application</h2>
            </div>
            <div className="pl-12 space-y-2 text-slate-600">
              <p><strong>Nom / Raison sociale :</strong> FISL</p>
              <p><strong>Statut juridique :</strong> SARL</p>
              <p><strong>Adresse :</strong> 4bis rue Ampère, 17110 Saint-Georges-de-Didonne</p>
              <p className="flex items-center gap-2">
                <Mail className="h-4 w-4" />
                <strong>Email :</strong> 
                <a href="mailto:contact@fisl.fr" className="text-[#8DC63F] hover:underline">
                  contact@fisl.fr
                </a>
              </p>
            </div>
          </section>

          {/* Responsable */}
          <section className="mb-8">
            <div className="flex items-center gap-3 mb-4">
              <div className="bg-blue-100 p-2 rounded-lg">
                <User className="h-5 w-5 text-blue-600" />
              </div>
              <h2 className="text-xl font-semibold text-[#0F172A]">Responsable de la publication</h2>
            </div>
            <div className="pl-12 text-slate-600">
              <p><strong>Romain Triqueneaux</strong></p>
            </div>
          </section>

          {/* Hébergement */}
          <section className="mb-8">
            <div className="flex items-center gap-3 mb-4">
              <div className="bg-purple-100 p-2 rounded-lg">
                <Server className="h-5 w-5 text-purple-600" />
              </div>
              <h2 className="text-xl font-semibold text-[#0F172A]">Hébergement</h2>
            </div>
            <div className="pl-12 space-y-2 text-slate-600">
              <p>L'application est hébergée par : <strong>Emergent</strong></p>
              <p className="text-sm text-slate-500">
                Plateforme de développement et d'hébergement d'applications
              </p>
            </div>
          </section>

          {/* Propriété intellectuelle */}
          <section className="mb-8 p-4 bg-slate-50 rounded-lg border border-slate-200">
            <h2 className="text-lg font-semibold text-[#0F172A] mb-3">Propriété intellectuelle</h2>
            <p className="text-slate-600 text-sm">
              L'ensemble des contenus (textes, images, logos, éléments graphiques) présents sur cette 
              application sont la propriété exclusive de FISL, sauf mention contraire. Toute reproduction, 
              représentation, modification ou exploitation non autorisée est interdite.
            </p>
          </section>

          {/* Lien RGPD */}
          <div className="text-center pt-4 border-t border-slate-200">
            <Link 
              to="/rgpd" 
              className="text-[#8DC63F] hover:underline font-medium"
            >
              Voir notre Politique de confidentialité & RGPD →
            </Link>
          </div>
        </div>

        <p className="text-center text-xs text-slate-400 mt-6">
          © {new Date().getFullYear()} FISL - Formation Internationale aux Sports de Loisirs
        </p>
      </div>
    </div>
  );
};

export default MentionsLegales;
